// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorApplications = (client) => ({
    /**
     * `POST /vendor/applications`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorApplicationsCreate
     * @source packages/modules/b2c-core/src/api/vendor/applications/route.ts
     */
    create: (body, query, headers) => client.fetch("/vendor/applications", { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/applications/:id/products`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorAttachProductsToApplication
     * @source packages/modules/b2c-core/src/api/vendor/applications/[id]/products/route.ts
     */
    createProduct: (id, body, query, headers) => client.fetch(buildPath("/vendor/applications/:id/products", [id]), { method: "POST", body, query, headers }),
    /**
     * `DELETE /vendor/applications/:id/products`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorDetachProductsFromApplication
     * @source packages/modules/b2c-core/src/api/vendor/applications/[id]/products/route.ts
     */
    deleteProduct: (id, body, query, headers) => client.fetch(buildPath("/vendor/applications/:id/products", [id]), { method: "DELETE", body, query, headers }),
    /**
     * `GET /vendor/applications`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorApplicationsList
     * @source packages/modules/b2c-core/src/api/vendor/applications/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/applications", { method: "GET", query, headers }),
    /**
     * `GET /vendor/applications/:id/products`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetApplicationProducts
     * @source packages/modules/b2c-core/src/api/vendor/applications/[id]/products/route.ts
     */
    listProducts: (id, query, headers) => client.fetch(buildPath("/vendor/applications/:id/products", [id]), { method: "GET", query, headers }),
    /**
     * `GET /vendor/applications/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorApplicationsIdRetrieve
     * @source packages/modules/b2c-core/src/api/vendor/applications/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/vendor/applications/:id", [id]), { method: "GET", query, headers }),
    /**
     * `GET /vendor/applications/:id/seo-content`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorApplicationsIdSeoContentRetrieve
     * @source packages/modules/b2c-core/src/api/vendor/applications/[id]/seo-content/route.ts
     */
    retrieveSeoContent: (id, query, headers) => client.fetch(buildPath("/vendor/applications/:id/seo-content", [id]), { method: "GET", query, headers }),
    /**
     * `PUT /vendor/applications/:id/seo-content`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorApplicationsIdSeoContentUpdate
     * @source packages/modules/b2c-core/src/api/vendor/applications/[id]/seo-content/route.ts
     */
    updateSeoContent: (id, body, query, headers) => client.fetch(buildPath("/vendor/applications/:id/seo-content", [id]), { method: "PUT", body, query, headers }),
});
//# sourceMappingURL=applications.js.map